import { useParams } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { Box, Typography, Avatar, Paper } from "@mui/material";
import Cris from "../../../assets/img/vereadoresImg/cris.png";
import Erivan from "../../../assets/img/vereadoresImg/erivan.png";
import Edilmo from "../../../assets/img/vereadoresImg/edilmo.png";
import Jailson from "../../../assets/img/vereadoresImg/jailson.png";
import Janaina from "../../../assets/img/vereadoresImg/janaina.png";
import Leandro from "../../../assets/img/vereadoresImg/leandro.png";
import Marcia from "../../../assets/img/vereadoresImg/marcia.png";
import Ovidio from "../../../assets/img/vereadoresImg/ovidio.png";
import Wagner from "../../../assets/img/vereadoresImg/wagner.png";

const vereadoresInfo = {
  crisazevedo: {
    nome: "Cris Azevedo",
    cargo: "Vereador(a) Presidente",
    partido: "PSDB",
    imagem: Cris,
    descricao1: "Nasceu em Serra Caiada/RN, no dia 13 de abril de 1980. Possui ensino superior completo e atua como professora na rede municipal.",
    descricao2:
      "Vereadora Eleita com 616 votos para o terceiro mandato na Câmara Municipal de Serra Caiada, sendo a mais votada nas eleições de 2024. Atualmente é a presidente da Casa Legislativa, cargo que já ocupou em 2021 e que já foi ocupado pelo seu pai, Jorge Antônio Azevedo Cruz no ano de 1985 e pela sua irmã, Ana Angélica Azevedo no ano de 2009.",
  },
  edilmolira: {
    nome: "Edilmo Lira",
    cargo: "Vereador(a)",
    partido: "PSDB",
    imagem: Edilmo,
    descricao1: "Nasceu em Natal/RN, no dia 25 de março de 1972. Possui ensino médio completo e atua como agricultor.",
    descricao2:
      "Vereador eleito com 518 votos para o sétimo mandato na Câmara Municipal de Serra Caiada, sendo o sexto mais votado nas eleições de 2024. Foi presidente da Câmara nos anos de 2007, 2013, 2014, 2020 e 2022.",
  },
  erivanelias: {
    nome: "Erivan Elias da Silva",
    cargo: "Vereador(a)",
    partido: "PSDB",
    imagem: Erivan,
    descricao1: "Nasceu em Serra Caiada/RN, no dia 01 de março de 1961. Possui ensino médio completo.",
    descricao2:
      "Vereador Eleito com 555 votos para o seu oitavo mandato na Câmara Municipal de Serra Caiada sendo o quinto mais votado nas eleições de 2024. Foi presidente da Câmara nos anos de 1997, 2005 e 2023.",
  },
  jailsonmendonca: {
    nome: "Jailson Mendonça da Silva",
    cargo: "Vereador(a)",
    partido: "PSDB",
    imagem: Jailson,
    descricao1: "Nasceu em Serra Caiada/RN, no dia 02 de dezembro de 1963. Possui ensino médio completo e atua como agricultor.",
    descricao2:
      "Vereador eleito com 569 votos para seu sétimo mandato na Câmara Municipal de Serra Caiada, sendo o quarto mais votado nas eleições de 2024. Foi presidente da Câmara nos anos de 2015 e 2018 e foi eleito para presidir a Cada Legislativa no ano de 2028.",
  },
  janainabezerra: {
    nome: "Janaína Patrícia Bezerra da Silva",
    cargo: "Vereador(a)",
    partido: "PSDB",
    imagem: Janaina,
    descricao1: "Nasceu em Natal/RN, no dia 30 de setembro de 1980. Possui ensino superior completo.",
    descricao2:
      "Vereadora eleita com 572 votos para seu segundo mandato na Câmara Municipal de Serra Caiada, sendo a terceira mais votada nas eleições de 2024. Foi eleita para presidir a Casa Legislativa em 2027.",
  },
  leandroeuclides: {
    nome: "Leandro Euclides Guedes da Costa",
    cargo: "Vereador(a)",
    partido: "MDB",
    imagem: Leandro,
    descricao1: "Nasceu em Natal/RN, no dia 31 de janeiro de 1985. Possui ensino médio completo e atua como empresário.",
    descricao2:
      "Vereador Eleito com 357 votos para seu terceiro mandato na Câmara Municipal de Serra Caiada, sendo o oitavo mais votado nas eleições de 2024. É empresário do ramo de Óticas, sendo proprietário da Ótica Nielly, com sede em Serra Caiada",
  },
  marciacosta: {
    nome: "Marcia Costa Araujo Gomes",
    cargo: "Vereador(a)",
    partido: "PV",
    imagem: Marcia,
    descricao1: "Nasceu em Serra Caiada/RN, no dia 30 de agosto de 1988. Possui ensino superior completo e atua como agricultora.",
    descricao2:
      "Eleita para seu primeiro mandato em Serra Caiada com 227 votos, sendo a nona mais votada nas eleições de 2024 é a única representante do seu partido (PV) na Casa Legislativa, foi eleita pela Federação Brasil da Esperança onde também integram os partidos PT e PCdoB.",
  },
  ovidiodeaquino: {
    nome: "Ovídio de Aquino e Silva Neto",
    cargo: "Vereador(a)",
    partido: "PSDB",
    imagem: Ovidio,
    descricao1: "Nasceu em Natal/RN, no dia 01 de maio de 1986. Possui ensino médio completo e atua como servidor público.",
    descricao2:
      "Vereador eleito com 578 votos para seu segundo mandato na Câmara Municipal de Serra Caiada, sendo o segundo mais votado nas eleições de 2024. É funcionário público com 15 anos de atuação na Prefeitura de Serra Caiada. Tabelinho foi eleito para presidir a Casa Legislativa no ano de 2026.",
  },
  wagnerferreira: {
    nome: "Wagner Ferreira Gonçalves",
    cargo: "Vereador(a)",
    partido: "MDB",
    imagem: Wagner,
    descricao1: "Nasceu em Natal/RN, no dia 20 de maio de 1981. Possui ensino médio completo e atua como agricultor.",
    descricao2:
      "Eleito para seu primeiro mandato em Serra Caiada com 366 votos, sendo o mais votado do seu partido (MDB) e o oitavo mais votado nas eleições de 2024. Kinho é agricultor e tem uma forte atuação no segmento do esporte.",
  },
};

const VereadorDetalhes = () => {
  const theme = useTheme();
  const { nome } = useParams();
  const vereador = vereadoresInfo[nome.toLowerCase()] || {};

  return (
    <Box
      sx={{
        width: "80%",
        padding: 4,
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Avatar
        src={vereador.imagem}
        sx={{
          width: 240,
          height: 240,
          margin: "0 auto",
          border: "solid #d4d4d4 5px",
        }}
      />
      <Typography variant="h4" sx={{ fontWeight: "bold", marginTop: 2 }}>
        {vereador.nome}
      </Typography>
      <Typography variant="h6" color="textSecondary">
        {vereador.cargo} - Partido: {vereador.partido}
      </Typography>
      <Paper sx={{ width: "80%", padding: "20px" }}>
        <Typography
          variant="h6"
          sx={{
            background: theme.palette.primary.main,
            color: theme.palette.primary.text,
            borderRadius: "10px",
          }}
        >
          Sobre mim:
        </Typography>
        <Typography variant="body1" sx={{ marginTop: 2 }}>
          {vereador.descricao1}
        </Typography>
        <Typography variant="body1" sx={{ marginTop: 2 }}>
          {vereador.descricao2}
        </Typography>
      </Paper>
    </Box>
  );
};

export { vereadoresInfo };
export default VereadorDetalhes;
